import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { AuthLayout } from '@/features/authentication/presentation/components/AuthLayout';
import { OnboardingForm } from '@/features/authentication/presentation/components/OnboardingForm';
import { Button } from '@/core/presentation/components/ui/Button';
import { useOnboardingBridge } from '@/features/authentication/presentation/composables/bridges/OnboardingBridge';

/**
 * Tela de onboarding — layout + formulário; tudo vem do `useOnboardingBridge`.
 */
export const OnboardingScreen: React.FC = () => {
  const { layout, exitFooter, form } = useOnboardingBridge();

  return (
    <AuthLayout
      title={layout.title}
      subtitle={layout.subtitle}
      footer={
        <Button
          type="button"
          variant="ghost"
          size="sm"
          loading={exitFooter.loading}
          loadingLabel={exitFooter.loadingLabel}
          onClick={() => void exitFooter.onExit()}
          className="font-medium text-cyan hover:text-cyan-light hover:underline hover:underline-offset-2 hover:bg-transparent focus-visible:underline focus-visible:underline-offset-2 focus-visible:ring-2 focus-visible:ring-cyan"
        >
          <span className="relative inline-block">
            <ArrowLeft
              className="pointer-events-none absolute right-full top-1/2 mr-4 size-4 shrink-0 -translate-y-1/2"
              aria-hidden
            />
            {exitFooter.label}
          </span>
        </Button>
      }
    >
      <OnboardingForm {...form} />
    </AuthLayout>
  );
};
